import { useEffect, useState } from "react";
import Logo from "@/components/Logo";

const LINKS = [
    ["passeios", "Jet ski"],
    ["clima", "Clima ao vivo"],
    ["contato", "Contato"],
];

export default function Nav({ scrollToId }) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "border-b border-neon-cyan/10 bg-ocean/80 backdrop-blur-xl"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-3 py-3 sm:px-8 sm:py-4">
                <Logo mobileCompact />
                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map(([id, label]) => (
                        <button
                            key={id}
                            onClick={() => scrollToId(id)}
                            data-testid={`nav-link-${id}`}
                            className="group relative font-mono2 text-[11px] font-semibold uppercase tracking-[0.25em] text-dim transition-colors hover:text-neon-cyan"
                        >
                            {label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-neon-cyan transition-all duration-300 group-hover:w-full" />
                        </button>
                    ))}
                </nav>

            </div>
        </header>
    );
}
